import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from 'src/stores/reducers';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
